import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Select from 'widgets/Select/Select';
import Textarea from 'widgets/Textarea/Textarea';
import Button from 'widgets/Button/Button';

export default class FeedbackForm extends PureComponent {
  static propTypes = {
    feedbackCorrectionTypes: PropTypes.arrayOf(PropTypes.string),
    isLoggedIn: PropTypes.bool,
    postFeedback: PropTypes.func,
    sku: PropTypes.string.isRequired,
  };

  state = {
    correctionType: '',
    comments: '',
  };

  componentDidUpdate(prevProps) {
    if (prevProps.sku !== this.props.sku) {
      this.clearForm();
    }
  }

  mapCorrectionTypes = () => {
    const options = this.props.feedbackCorrectionTypes.map(correctionType => ({
      name: correctionType,
      value: correctionType,
    }));

    options.unshift({
      name: 'Select area',
      value: '',
    });

    return options;
  }

  updateFeedback = (name, value) => {
    this.setState({
      [name]: value,
    });
  }

  clearForm = () => {
    this.setState({
      correctionType: '',
      comments: '',
    });
  }

  handleSubmit = () => {
    const { correctionType, comments } = this.state;
    this.props.postFeedback(
      {
        correctionType,
        comments,
      },
      this.props.sku
    );
    this.clearForm();
  };

  canPostFeedback = () => this.state.comments.trim() && this.state.correctionType;

  isCorrectionTypeEmpty = () => !this.state.correctionType && !!this.state.comments;

  render() {
    const { correctionType, comments } = this.state;
    const { isLoggedIn, feedbackCorrectionTypes, postFeedback } = this.props;

    if (!isLoggedIn || !feedbackCorrectionTypes || !postFeedback) {
      return null;
    }

    return (
      <section className="bop-section bop-feedback">
        <h4>Spotted a mistake? Let us know.</h4>
        <Select
          className="bop-feedback__correctionType"
          name="correctionType"
          label="Select type of mistake"
          required
          options={this.mapCorrectionTypes()}
          onChange={this.updateFeedback}
          value={correctionType}
          errorMessage={this.isCorrectionTypeEmpty()
            ? 'Please select the type of mistake that you have spotted.'
            : ''
          }
        />
        <Textarea
          className="bop-feedback__comments"
          name="comments"
          label="Describe the problem"
          required
          placeholder="Max. of 4,000 characters"
          onChange={this.updateFeedback}
          value={comments}
          maxLength="4000"
          rows={4}
        />
        <Button
          className="bop-feedback__submit"
          onClick={this.handleSubmit}
          disabled={!this.canPostFeedback()}
        >
          Submit
        </Button>
      </section>
    );
  }
}
